import SelectTriggerBtn from '../Component.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(
      config,
      'selectTriggerBtn',
      SelectTriggerBtn
    );
  },
};
